export function makeStringUrlSafe(value) {
  // Remove all punctuation characters except for `_` and `-` characters.
  let result = value.replace(/[^\p{L}\s_-]/gu, '');

  // Replace all illegal characters with an underscore.
  result = result.replace(/[^a-z0-9]/gi, '_');

  // Replace multiple characters in a row with a single underscore.
  result = result.replace(/_{2,}/g, '_');

  return result;
}
